import React, { useContext } from "react";
import styled from "styled-components";
import { setCookie } from "../../../modules/utils/cookie";
import { AppContext, SocketCommand, socketManager } from "../../../components/AppProvider";
import { closeLayerFn } from "../../Layout";
import NextArrowOrange from "../../../resources/images/icon/next_arrow_orange.svg";
import EduGuideImg from "../../../resources/images/icon/hospital_img01.svg";
import IconHspt from "../../../resources/images/icon/icon_sidemenu02_1.svg";
import IconArrow from "../../../resources/images/icon/icon_back_black.png";

const MdEduLayer = () => {
  const { userinfo } = useContext(AppContext);
  const clickEvent = () => {
    const toYear = new Date().getFullYear();
    setCookie("viewEduLayer", toYear, 365);

    socketManager(SocketCommand.MD_EDUCO_CONNECT, "", {
      moveUrl:
        "http://m.mdeduco.com//court_class/login_proc.php?params=" +
        encodeURIComponent(userinfo.app.setInfo.studyDesc),
    });

    closeLayerFn($("#mdEduLayer"));
  };

  const clickEventClose = () => {
    const toYear = new Date().getFullYear();
    setCookie("viewEduLayer", toYear, 365);

    closeLayerFn($("#mdEduLayer"));
  };

  return (
    <div className="blacklayer-container" style={{ zIndex: "39" }} id="mdEduLayer">
      <div className="bl-blind"></div>
      <div className="in-layerarea nobtn">
        <div
          className={"blgrn-box vertical"}
          style={{
            borderRadius: "28px 28px 0px 0px",
            margin: "0px 46px",
            width: "calc(100% - 92px)",
            padding: "0px",
            background: "white",
          }}
        >
          <div
            className="blgr-title"
            style={{ marginTop: "18px", textAlign: "center", color: "black", fontWeight: "700" }}
          >
            법정교육 수강 방법
          </div>
          <div
            style={{
              textAlign: "center",
              color: "#A9A9A9",
              margin: "0px 20px",
              borderBottom: "dotted",
              marginTop: "17px",
              paddingBottom: "13px",
              fontSize: "14px",
              fontWeight: "700",
            }}
          >
            개인진료기록 {"->"} 교육자료 {"->"} 법정교육
          </div>

          {/* 개인진료기록 */}
          <div
            style={{
              margin: "8px auto",
              width: "92px",
              height: "92px",
              borderRadius: "12px",
              boxShadow: "0px 3px 3px 3px #b9b9b9",
              textAlign: "center",
            }}
          >
            <img src={IconHspt} style={{ marginTop: "10px" }} />
            <div style={{ color: "#A0A0A0", fontSize: "14px", fontWeight: "700" }}>
              개인진료기록
            </div>
          </div>
          {/* 개인진료기록 */}
          <div style={{ textAlign: "center" }}>
            <img src={NextArrowOrange} />
          </div>
          {/* 교육자료 */}
          <div
            style={{
              margin: "8px auto",
              width: "102px",
              height: "44px",
              borderRadius: "20px",
              color: "#B990F2",
              border: "1px solid",
              textAlign: "center",
              lineHeight: "44px",
              fontSize: "14px",
              fontWeight: "700",
              boxShadow: "0px 3px 3px 3px #c1c1c1",
            }}
          >
            교육자료
          </div>
          {/* 교육자료 */}
          <div style={{ textAlign: "center" }}>
            <img src={NextArrowOrange} />
          </div>
          {/* 이미지 */}
          <div style={{ width: "171px", margin: "4px auto 14px auto" }}>
            <img
              src={EduGuideImg}
              style={{ borderRadius: "12px", boxShadow: "3px 3px 3px 3px gray" }}
            />
          </div>
          {/* 이미지*/}

          <div className="tbns-area">
            <div style={{ display: "flex", bottom: "0px" }}>
              <div
                style={{
                  background: "#EAEAEA",
                  color: "#A9A9A9",
                  width: "50%",
                  height: "44px",
                  lineHeight: "44px",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
                onClick={() => clickEventClose()}
              >
                닫기
              </div>
              <div
                style={{
                  background: "#0297EE",
                  color: "white",
                  width: "50%",
                  height: "44px",
                  lineHeight: "44px",
                  textAlign: "center",
                  fontSize: "14px",
                  fontWeight: "700",
                }}
                onClick={() => clickEvent()}
              >
                바로가기
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MdEduLayer;

const LayerContainer = styled.div`
  // display: none;
  margin: 0px 20px;
`;

const 바로가기버튼 = styled.div`
  width: 100%;
  margin: 0px 20px;
`;
